export default "__VITE_ASSET__4gk5MYOH__";